export default "__VITE_ASSET__CQDZ1WMb__"